module.exports = __webpack_public_path__ + "static/media/roles.784d2bdb.svg";